(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasis-tour-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('oasis-tour-search')) return;

    class OasisTourSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-oasis-search-input]');
        this.results = this.querySelector('[data-oasis-search-results]');
        this.form = this.querySelector('[data-oasis-search-form]');

        if (!this.input || !this.results) return;

        this.timer = null;
        this.controller = null;

        this.handleInput = this.handleInput.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);

        this.input.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleDocumentClick);
      }

      disconnectedCallback() {
        if (this.input) {
          this.input.removeEventListener('input', this.handleInput);
          this.input.removeEventListener('keydown', this.handleKeydown);
        }

        document.removeEventListener('click', this.handleDocumentClick);

        if (this.timer) {
          clearTimeout(this.timer);
        }

        if (this.controller) {
          this.controller.abort();
        }
      }

      handleInput() {
        const query = this.input.value.trim();

        if (this.timer) {
          clearTimeout(this.timer);
        }

        if (query.length < 2) {
          this.closeResults(true);
          return;
        }

        this.timer = setTimeout(() => {
          this.getResults(query);
        }, 220);
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.closeResults(false);
          this.input.focus();
        }
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.closeResults(false);
        }
      }

      async getResults(query) {
        if (!this.dataset.predictiveUrl) return;

        if (this.controller) {
          this.controller.abort();
        }

        this.controller = new AbortController();

        const url = new URL(this.dataset.predictiveUrl, window.location.origin);

        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');
        url.searchParams.set(
          'resources[options][fields]',
          'title,product_type,variants.title'
        );
        url.searchParams.set('resources[options][prefix]', 'last');
        url.searchParams.set('section_id', 'oasis-tour-search');

        try {
          const response = await fetch(url.toString(), {
            signal: this.controller.signal,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) return;

          const html = await response.text();

          if (query !== this.input.value.trim()) return;

          const documentFragment = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          const template = documentFragment.querySelector(
            '[data-oasis-search-results-template]'
          );

          if (!template) {
            this.closeResults(true);
            return;
          }

          this.results.innerHTML = template.innerHTML;
          this.results.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('Oasis Tour Search:', error);
          }
        }
      }

      closeResults(clearContent = false) {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');

        if (clearContent) {
          this.results.innerHTML = '';
        }
      }
    }

    customElements.define('oasis-tour-search', OasisTourSearch);
  })();

  } catch(e) { console.error(e); }
})();
})();
